<template>
    <div class="clientes">
        <div class="ancla2" id="clientes"></div>
        <div class="content">
            <h3>empresas que han confiado en el modelo</h3>
            <slick ref="slick" :options="slickOptions">
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/1.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/7.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/2.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/8.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/3.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/9.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/4.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/10.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/5.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/11.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/6.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/12.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/13.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/16.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/14.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/17.png" alt="cliente">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="cliente">
                        <div class="img1">
                            <img src="../assets/img/clientes/15.png" alt="cliente">
                        </div>
                        <div class="img2">
                            <img src="../assets/img/clientes/18.png" alt="cliente">
                        </div>
                    </div>
                </div>
            </slick>
        </div>
    </div>
</template>

<script>
    import Slick from 'vue-slick'
    export default {
        components: {
            Slick
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 6,
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    slidesToScroll: 6,
                    infinity: false,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 550,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                },
            };
        },
        methods: {
            next() {
                this.$refs.slick.next()
            },
            prev() {
                this.$refs.slick.prev()
            },
            reInit() {
                this.$refs.slick.reSlick()
            }
        }
    }
</script>

<style scoped>
    .clientes{
        padding-bottom: 124px;
        position: relative;
    }
    h3{
        margin-bottom: 30px!important;
    }
    .cliente{
        padding: 40px;
    }
    img{
        width: 100%;
    }
    .img1{
        margin-bottom: 40px;
    }

    
    @media screen and (max-width: 767px){
        .clientes{
            padding-bottom: 104px;
        }
    }
</style>
<style>
    .clientes .slick-dots li, .clientes .slick-dots li button{
        width: 25px;
        height: 3px;
    }
    .clientes .slick-dots li button:before{
        content: url('../assets/img/icn_line_white.png');
        opacity: 1;
    }
    .clientes .slick-dots li.slick-active button:before{
        content: url('../assets/img/icn_line_orange.png');
    }

</style>


// WEBPACK FOOTER //
// src/components/Clientes.vue